import tabStates from '@enums/tab-states';

function validateProductsTab({ promotion }) {
    return (promotion.products || []).length ? tabStates.completed : tabStates.invalid;
}

export default {
    validateProductsTab,
};
